import { render } from "./SettingsContactForm.vue?vue&type=template&id=2d84f018"
import script from "./SettingsContactForm.vue?vue&type=script&lang=js"
export * from "./SettingsContactForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\tatsa\\Desktop\\PROJETS\\SUFOSERVICES\\sufo-webadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__